import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import Home from "./pages/Home";
import Games from "./pages/Games";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import About from "./pages/About";
import Navbar from "./components/Navbar";
import "./App.css";
import GameDetails from "./pages/GameDetails";
import StoreGo from "./pages/StoreGo";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TermsOfService from "./pages/TermsOfService";
import Support from "./pages/Support";
import AdsApi from "./pages/AdsApi";
import Accessibility from "./pages/Accessibility";
import SuperSound from "./pages/SuperSound";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  }, [pathname]);

  return null;
}

function RedirectGamesToApps() {
  const { id } = useParams();
  return <Navigate to={id ? `/apps/${id}` : "/apps"} replace />;
}

function AppLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const isSuperSound = location.pathname.startsWith("/sound");

  return (
    <>
      {!isSuperSound && (
        <a href="#main-content" className="skip-link">
          {t("a11y_skip_to_content")}
        </a>
      )}
      <ScrollToTop />
      {!isSuperSound && <Navbar />}
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apps" element={<Games />} />
          <Route path="/apps/:id" element={<GameDetails />} />
          <Route path="/go/:id" element={<StoreGo />} />
          <Route path="/games" element={<Navigate to="/apps" replace />} />
          <Route path="/games/:id" element={<RedirectGamesToApps />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/support" element={<Support />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/ads-api" element={<AdsApi />} />
          <Route path="/sound" element={<SuperSound />} />
        </Routes>
    </>
  );
}

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const dir = i18n.language === "he" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", i18n.language);
    i18n.changeLanguage(i18n.language);
  }, [i18n.language]);

  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
